import { Link, useLocation } from 'react-router-dom';
import { Headphones, BookOpen, Sparkles, Activity, User } from 'lucide-react';

const tabs = [
  { name: 'Compte', path: '/aide', icon: User },
  { name: 'Programme', path: '/programme', icon: Headphones },
  { name: 'Méthode', path: '/methode', icon: BookOpen },
  { name: 'Outils', path: '/outils', icon: Sparkles },
  { name: 'Suivi', path: '/suivi', icon: Activity },
];

export const BottomNav = () => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 h-20 glass border-t border-sand-200 z-50" data-testid="bottom-navigation">
      <div className="flex items-center justify-around h-full max-w-lg mx-auto px-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname.startsWith(tab.path);

          return (
            <Link
              key={tab.path}
              to={tab.path}
              data-testid={`nav-tab-${tab.name.toLowerCase()}`}
              className={`flex flex-col items-center justify-center flex-1 h-full space-y-1 ${
                isActive ? 'text-declic' : 'text-sage-500/60'
              }`}
            >
              <Icon className="w-6 h-6" strokeWidth={1.5} />
              <span className="text-xs font-sans">{tab.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;